<template>
  <div class="content-accordion">
    <div class="inner">
      <h2 v-if="data.title" class="title" v-html="data.title" />
      <AccordionItem v-for="item in data.items" :key="item.id" class="item" :item="item" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContentAccordionFragment } from '#gql';
import AccordionItem from '~/components/content-modules/components/AccordionItem.vue';

defineProps<{
  data: ContentAccordionFragment;
}>();
</script>

<style scoped lang="scss">
.content-accordion {
  @include grid-layout();

  & {
    padding: var(--site-inner-padding);
    width: 100%;
    max-width: var(--site-max-width);
  }

  > .inner {
    display: grid;
    padding: var(--spacing-2xl) 0;
    width: 100%;

    @media (--xs) {
      grid-column: 1 / -1;
    }

    @media (--sm) {
      grid-column: 2 / 24;
    }

    @media (--md), (--lg) {
      grid-column: 5 / 21;
    }

    > .title {
      color: var(--color-forest-dark);

      @media (--xs), (--sm) {
        margin-bottom: var(--spacing-2xs);
      }

      @media (--md), (--lg) {
        margin-bottom: var(--spacing-xs);
      }
    }

    > .item {
      color: var(--color-forest-dark);
      border-bottom: 1px solid var(--color-forest-dark);
      padding: var(--spacing-3xs) 0;

      &:first-of-type {
        border-top: 1px solid var(--color-forest-dark);
      }
    }
  }
}
</style>
